import { Route, Navigate } from "react-router";
import AccessDeniedError from "../components/pages/AccessDeniedError";

const UnAuthorizedRoutes = (
  <>
    <Route
      data-testid="deniedErrorRoute"
      path="/403"
      element={<AccessDeniedError />}
    />
    <Route path="*" element={<Navigate to="/403" replace />} />
  </>
);

export default UnAuthorizedRoutes;
